import { useInvalidateCadenceState } from '@/hooks/trpc/useCadenceMutation';
import { api } from '@/utils/api';

export const useGlobalReminderDelete = () => {
  const utils = api.useUtils();
  const invalidateCadenceState = useInvalidateCadenceState();
  return api.globalReminder.delete.useMutation({
    onSuccess: () => {
      // Deleting a campaign step's reminder ("Done") finishes that step server-side, so refresh
      // every campaign view. That includes the reminder lists and the contact-detail bootstrap the
      // reminder card renders from.
      void invalidateCadenceState();
      void utils.contact.responded.invalidate();
      void utils.contact.contentViewed.invalidate();
      void utils.contact.getConnected.invalidate();
      void utils.contact.getConnectedGroupedByOrg.invalidate();
    },
  });
};

export const useGlobalReminderDeleteBulk = () => {
  const utils = api.useUtils();
  const invalidateCadenceState = useInvalidateCadenceState();
  return api.globalReminder.deleteBulk.useMutation({
    onSuccess: () => {
      // Same as the single delete: a campaign step's reminder going away finishes the step.
      void invalidateCadenceState();
      void utils.contact.getConnected.invalidate();
      void utils.contact.getConnectedGroupedByOrg.invalidate();
    },
  });
};

export const useGlobalReminderCreate = () => {
  const utils = api.useUtils();
  return api.globalReminder.create.useMutation({
    onSuccess: (data) => {
      void utils.globalReminder.allForContact.invalidate({ contactId: data.contactId });
      void utils.globalReminder.paginated.invalidate();
      // Reminders render off the contact-detail bootstrap query; invalidate it so a newly created
      // reminder shows up immediately instead of requiring a page refresh.
      void utils.contactDetailBootstrap.forContact.invalidate({ contactId: data.contactId });
      void utils.cadence.cadencesForCards.invalidate();
      void utils.contact.responded.invalidate();
      void utils.contact.contentViewed.invalidate();
      void utils.contact.getConnected.invalidate();
      void utils.contact.getConnectedGroupedByOrg.invalidate();
    },
  });
};

export const useGlobalReminderUpdate = () => {
  const utils = api.useUtils();
  return api.globalReminder.update.useMutation({
    onSuccess: (data) => {
      void utils.globalReminder.allForContact.invalidate({ contactId: data.contactId });
      void utils.globalReminder.paginated.invalidate();
      void utils.contactDetailBootstrap.forContact.invalidate({ contactId: data.contactId });
      void utils.cadence.cadencesForCards.invalidate();
      void utils.contact.responded.invalidate();
      void utils.contact.contentViewed.invalidate();
      void utils.contact.getConnected.invalidate();
      void utils.contact.getConnectedGroupedByOrg.invalidate();
    },
  });
};

export const useGlobalReminderChangeOwner = () => {
  const utils = api.useUtils();
  return api.globalReminder.changeOwner.useMutation({
    onSuccess: (data) => {
      void utils.globalReminder.allForContact.invalidate({ contactId: data.contactId });
      void utils.globalReminder.paginated.invalidate();
      void utils.contactDetailBootstrap.forContact.invalidate({ contactId: data.contactId });
      void utils.cadence.cadencesForCards.invalidate();
      void utils.contact.responded.invalidate();
      void utils.contact.contentViewed.invalidate();
      void utils.contact.getConnected.invalidate();
      void utils.contact.getConnectedGroupedByOrg.invalidate();
    },
  });
};
